<script setup lang="ts">
const props = withDefaults(defineProps<{
  w?: string
}>(), {
  w: '',
})


const $attrs = useAttrs()

const filteredAttrs = computed(() => {
  const myAttrs = { ...$attrs }
  delete myAttrs.class

  return myAttrs
})
</script>

<template>
  <div class="m-actions">
    <Wrap
      v-bind="filteredAttrs" :class="w"
    >
      <slot />
    </Wrap>
  </div>
</template>

<style lang="scss" scoped>
.m-actions {
  // First level wrap

  :deep(> .m-wrap) {
    
    display:flex;
    flex-direction: column;
    place-items: flex-start;

    gap: gr(0.5);

    @include mq($from: txs) {
      flex-direction: row;
      
    }

  }
}
</style>
